import { Typography } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

export function Confirmed() {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <div className={classes.root}>
      <header>
        <img src='assets/img/logo-cromai.svg' alt='Logo Cromai' />
      </header>
      <div>
        <section>
          <Typography variant='h1'>
            Olá, parece que você entrou em uma <strong>nova companhia</strong>.
          </Typography>
          <Typography>
            Vamos ver como fazer as mudanças de companhia? É mais fácil do que
            você imagina!
          </Typography>
          <Typography>
            - A imagem ao lado irá demonstrar como realizar as transições
            rapidamente.
          </Typography>
        </section>
        <img
          src='assets/img/example-confirm-company.svg'
          alt='Imagem de exemplo para alterar para a nova companhia'
        />
      </div>
      <Button onClick={() => navigate(routes.Login())}>
        Entrar na minha conta
      </Button>

      <img
        src='assets/img/logotipo-cromai.svg'
        alt='Logotipo de fundo da Cromai'
      />
    </div>
  )
}
